export const ANONYMOUS_PERMISSION_SEARCH_RESULTS = 'search_results';

export function isAnonymousFlowEnabled(profile, permission) {
    return Boolean(
        permission &&
            profile?.company?.settings?.allow_anonymous_users &&
            profile?.company?.settings?.anonymous_user_permissions?.[permission],
    );
}
